import { FormattedMessage } from 'react-intl';

import {
  InViewTracking,
  useInsightsTracking,
} from '@xing-com/crate-insights-tracking';
import { Hero } from '@xing-com/typography';

import { SignUpButton } from '../sign-up-button';

import { Styled } from './teaser-sign-up.styled';

const TRACKED_LINK =
  '/start/signup?sc_o=insights_sign_up_click&sc_o_PropActionOrigin=discover_update_InsightsScreenBottom&signup_channel=minireg_insights';

const trackData = {
  element: 'sign_up',
  element_detail: 'insights_screen_bottom',
  position: 5,
  verticalPosition: 5,
};

export const TeaserSignUp = (): JSX.Element => {
  const { trackWithNWT } = useInsightsTracking();
  const track = (): void => trackWithNWT({ event: 'opened', ...trackData });

  return (
    <InViewTracking nwtTrackingOptions={trackData}>
      <Styled.Section>
        <Hero size="small" sizeWide="medium" noMargin>
          <FormattedMessage id="INSIGHTS_LO_SIGNUP_TEASER_TITLE" />
        </Hero>
        <Styled.BodyCopy size="large" sizeWide="xlarge">
          <FormattedMessage id="INSIGHTS_LO_SIGNUP_TEASER_DESCRIPTION" />
        </Styled.BodyCopy>
        <SignUpButton size="large" to={TRACKED_LINK} onClick={track}>
          <FormattedMessage id="INSIGHTS_LO_SIGNUP_TEASER_CTA" />
        </SignUpButton>
      </Styled.Section>
    </InViewTracking>
  );
};
